/**
 * Events that are fired during playback
 */
export enum MKEvent {
  Playing = 'playing',
  Paused = 'paused',
  Ready = 'ready',
  TimeChanged = 'timechanged',
  Error = 'error',
  BufferingStarted = 'bufferingstarted',
  BufferingEnded = 'bufferingended',
  StreamFinished = 'streamfinished',
  Warning = 'warning',
  QualityChanged = 'qualitychanged',
  SegmentPlayback = 'segmentplayback',
  Unloaded = 'unloaded',
  MetadataParsed = 'metadataparsed',
  Metadata = 'metadata',
}